import { ausrehabApi as baseApi } from '../baseApi';
import type { TestProps } from '../../models';

const testApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getTest: builder.query({
			query: (id) => ({
				url: `tests/${id}`,
			}),
			providesTags: ['Tests'],
		}),

		getTests: builder.query<TestProps[], void>({
			query: () => ({
				url: 'tests',
			}),
			providesTags: ['Tests'],
		}),

		getBulkTests: builder.query<TestProps[], void>({
			query: () => ({
				url: 'tests?isBulk=true',
			}),
			providesTags: ['Tests'],
		}),

		delTest: builder.mutation({
			query: (id) => ({
				url: `tests/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Tests'],
		}),

		addTest: builder.mutation({
			query: (payload) => {
				return {
					url: 'tests',
					method: 'POST',
					body: payload,
				};
			},
			invalidatesTags: ['Tests'],
		}),

		updateTest: builder.mutation({
			query: ({ id, ...payload }) => {
				return {
					url: `tests/${id}`,
					method: 'PUT',
					body: payload,
				};
			},
			invalidatesTags: ['Tests'],
		}),

		orderTests: builder.mutation({
			query: ({ tests }) => {
				return {
					url: 'tests/order',
					method: 'PUT',
					body: tests,
				};
			},
			invalidatesTags: ['Tests'],
		}),
	}),
	overrideExisting: false,
});

export const {
	useGetTestsQuery,
	useGetTestQuery,
	useGetBulkTestsQuery,

	// mutation
	useAddTestMutation,
	useDelTestMutation,
	useOrderTestsMutation,
	useUpdateTestMutation,
} = testApi;
